import React from 'react';
import { useLocation } from 'react-router-dom';
import {
  Image,
  ScrollView,
  StyleSheet,
  View,
  Text,
  TouchableWithoutFeedback,
} from './base_components';
import LinkHighlight from './buttons/link_highlight';
import ImageButton from './buttons/image_button';

import { useUser } from '../stores/user_store';

import util from '../tools/util';

const styles = StyleSheet.create({
  leftNav: {
    paddingTop: '1rem',
    width: 0,
    alignSelf: 'stretch',
    backgroundColor: 'rgba(0,0,0,0.8)',
    '@media (min-width: 600px)': {
      width: '26rem',
    },
    '@media (max-width: 600px)': {
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
    },
    overflow: 'hidden',
  },
  closed: {
    width: '0px !important',
  },
  open: {
    '@media (max-width: 600px)': {
      width: '100vw',
    },
  },
  scroller: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    flexDirection: 'column',
    backgroundColor: 'var(--sidebar-bg-color)',
    borderRightWidth: 1,
    borderRightColor: 'var(--sidebar-border-color)',
    '@media (max-width: 600px)': {
      right: '20vw',
    },
    scrollbarColor: 'var(--sidebar-scroll-color) var(--sidebar-bg-color)',
  },
  scrollerInner: {
    minHeight: '100%',
    alignSelf: 'stretch',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  minLogo: {
    marginLeft: '1rem',
    marginTop: '1rem',
    height: '4rem',
    flexDirection: 'row',
    alignSelf: 'stretch',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  minButton: {
    height: '2rem',
    width: '2rem',
    padding: '1rem',
    borderRadius: '0.5rem',
    filter: 'var(--icon-grey)',
  },
  logo: {
    marginLeft: '1rem',
    width: '10rem',
    height: '2.8rem',
    marginRight: '1rem',
    //filter: 'var(--icon-header-grey)',
  },
  listItem: {
    marginLeft: '1rem',
    marginRight: '1rem',
    marginTop: '0.4rem',
    marginBottom: '0.4rem',
    paddingRight: '1rem',
    paddingLeft: '1rem',
    alignSelf: 'stretch',
    height: '3.8rem',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    borderRadius: '0.5rem',
    overflow: 'hidden',
  },
  textView: {
    marginLeft: '1rem',
    flex: 1,
    flexDirection: 'column',
    overflow: 'hidden',
  },
  text: {
    display: 'block',
    //maxWidth: '100%',
    color: 'var(--sidebar-text-color)',
    fontSize: '1.4rem',
    fontWeight: 'normal',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  childText: {
    fontWeight: 'normal',
  },
  active: {
    backgroundColor: '#e2e2e2',
  },
  activeText: {
    fontWeight: '600',
  },
  icon: {
    width: '2rem',
    height: '2rem',
  },
  iconSpacer: {
    width: '2rem',
  },
  up: {
    marginRight: '0.6rem',
    width: '1.6rem',
    height: '1.6rem',
    transform: 'rotate(0deg)',
  },
  upClosed: {
    transform: 'rotate(180deg)',
  },
  middlePad: {
    flex: 1,
    minHeight: '2rem',
  },
  userView: {
    marginLeft: '1.5rem',
    marginRight: '1.5rem',
    marginTop: '1.7rem',
    marginBottom: '3rem',
    paddingLeft: '1rem',
    paddingRight: '1rem',
    height: '5.6rem',
    alignSelf: 'stretch',
    backgroundColor: 'white',
    borderRadius: '1rem',
    borderWidth: 1,
    borderColor: 'var(--sidebar-account-border)',
    boxShadow: '0 4px 4px rgba(0,0,0,0.07)',
  },
  userInner: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  circle: {
    width: '3rem',
    height: '3rem',
    borderRadius: '3rem',
    backgroundColor: 'black',
    justifyContent: 'center',
    alignItems: 'center',
  },
  fakeIcon: {
    width: '2rem',
    height: '2rem',
    filter: 'var(--icon-white)',
  },
  nameEmail: {
    marginLeft: '1rem',
    flex: 1,
    alignSelf: 'stretch',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  userName: {
    marginBottom: '0.3rem',
    display: 'block',
    color: 'var(--sidebar-username-color)',
    fontSize: '1.2rem',
    fontWeight: '600',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  email: {
    display: 'block',
    color: 'var(--sidebar-email-color)',
    fontSize: '1.2rem',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  verView: {
    position: 'absolute',
    bottom: 4,
    left: 4,
  },
  ver: {
    color: '#333',
    fontSize: 8,
  },
});
const UP = require('../assets/img/up_grey.svg');
const ORG = require('../assets/img/org_color.svg');
const MIN = require('../assets/img/collapse_black.svg');
const LOGO = require('../assets/img/logo.png');
const ICON = require('../assets/img/maxlo_icon.svg');

type Props = {
  style?: any;
  open: boolean;
  closed: boolean;
  onClose: () => void;
  onClick: () => void;
};
export default function LeftNav(props: Props) {
  const { style, open, closed, onClose, onClick } = props;
  const user = useUser();
  const location = useLocation();
  const pathname = location?.pathname;
  const volume_list = [];

  const list = [
    {
      text: 'Orgs',
      url: '/org',
      icon: ORG,
    },
  ];

  return (
    <View
      style={[
        styles.leftNav,
        closed ? styles.closed : null,
        open ? styles.open : null,
        style,
      ]}
    >
      <TouchableWithoutFeedback
        style={StyleSheet.absoluteFill}
        onPress={onClick}
      >
        <View style={StyleSheet.absoluteFill} />
      </TouchableWithoutFeedback>
      <ScrollView
        style={styles.scroller}
        contentContainerStyle={styles.scrollerInner}
      >
        <View style={styles.verView}>
          <Text style={styles.ver}>{process.env.VERSION}</Text>
        </View>
        <View style={styles.minLogo}>
          <ImageButton
            style={styles.minButton}
            underlayColor='rgba(0,0,0,0.05)'
            source={MIN}
            onPress={onClose}
          />
          <Image style={styles.logo} source={LOGO} />
        </View>
        {list.map((item, i) => {
          return (
            <ListEntry
              key={i}
              item={item}
              pathname={pathname}
              volumeList={volume_list}
              onClick={onClick}
            />
          );
        })}
        <View style={styles.middlePad} />
        <LinkHighlight
          style={styles.userView}
          underlayColor='rgba(0,0,0,0.01)'
          url='/account'
          onPress={onClick}
        >
          <View style={styles.userInner}>
            <View style={styles.circle}>
              <Image style={styles.fakeIcon} source={ICON} />
            </View>
            <View style={styles.nameEmail}>
              {user?.user_name ? (
                <Text style={styles.userName}>{user.user_name}</Text>
              ) : null}
              <Text style={styles.email}>{user.email}</Text>
            </View>
          </View>
        </LinkHighlight>
      </ScrollView>
    </View>
  );
}
function ListEntry(props) {
  const { pathname, item, volumeList, onClick } = props;
  let content: any = null;
  const curr_volume = volumeList?.find?.(
    (v) =>
      pathname.startsWith(`/volume/${v.volume_id}`) ||
      pathname.startsWith(`/setting/${v.volume_id}`) ||
      pathname.startsWith(`/metric/${v.volume_id}`) ||
      pathname.startsWith(`/audit/${v.volume_id}`)
  );
  const is_active = pathname.startsWith(item.url);
  const show_arrow = item?.children?.length > 0;

  let child_active: boolean = false;
  let list: any = [];
  item.children?.forEach?.((child) => {
    const { insert_volumes } = child;
    if (insert_volumes && volumeList?.length > 0) {
      volumeList.forEach((volume) => {
        if (!volume.is_disabled && volume.is_user_volume) {
          const vol_active = volume.volume_id === curr_volume?.volume_id;
          child_active ||= vol_active;
          list.push(
            <ListItem
              key={volume.volume_id}
              url={`/volume/${volume.volume_id}/`}
              text={volume.volume_name}
              isActive={vol_active}
              isChild={true}
              showArrow={false}
              onClick={onClick}
            />
          );
        }
      });
    }
  });
  content = (
    <ListItem
      text={item.text}
      url={item.url}
      icon={item.icon}
      showArrow={show_arrow}
      isActive={is_active && !child_active}
      onClick={onClick}
    >
      {list}
    </ListItem>
  );
  return content;
}
const g_closedMap = new Map<string, boolean>();
function ListItem(props) {
  const { text, icon, url, showArrow, isChild, isActive, onClick } = props;
  const [is_closed, setClosed] = React.useState(g_closedMap.get(url) ?? false);

  function _onPress(e: any) {
    let ret;
    if (isActive && !isChild && props.children?.length > 0) {
      util.stopAll(e);
      const new_val = !is_closed;
      g_closedMap.set(url, new_val);
      setClosed(new_val);
      ret = false;
    }
    onClick?.();
    return ret;
  }
  return (
    <>
      <LinkHighlight
        style={[styles.listItem, isActive ? styles.active : null]}
        underlayColor='rgba(0,0,0,0.05)'
        url={url}
        onPress={_onPress}
      >
        {icon ? (
          <Image style={styles.icon} source={icon} />
        ) : (
          <View style={styles.iconSpacer} />
        )}
        <View style={styles.textView}>
          <Text
            style={[
              styles.text,
              isChild ? styles.childText : null,
              isActive ? styles.activeText : null,
            ]}
          >
            {text}
          </Text>
        </View>
        {showArrow ? (
          <Image
            style={[styles.up, is_closed ? styles.upClosed : null]}
            source={UP}
          />
        ) : null}
      </LinkHighlight>
      {is_closed ? null : props.children}
    </>
  );
}
